import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "antd/es/modal/style/css";
import _Modal from "antd/es/modal";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.json.stringify.js";
import React from 'react';
import { AsyncMessage } from '@libs/a-component/antd/AsyncMessage';
import { request, EAPIErrorType } from '@libs/utils';
import * as QS from 'query-string';
import { sendCustomLoginRedirect, uploadAPITime, uploadBusinessError, uploadHttpError } from '@/index.config';
import { initRequest_isSend } from './request';
export function initRequest() {
  var apiErrorCount = 0;
  /**
   * 接口出错时弹出 message
   */
  request.addErrorHandler(function (err) {
    if (+err.errno === 404) {
      apiErrorCount += 1;
      if (apiErrorCount > 1) {
        return;
      }
      _Modal.warning({
        title: '没有权限',
        content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "\u62B1\u6B49\uFF0C\u4F60\u6CA1\u6709\u76F8\u5E94\u529F\u80FD\u7684\u6743\u9650\u3002\u5982\u679C\u4F60\u6709\u9700\u8981\uFF0C\u8BF7\u70B9\u51FB\u6B64\u5904", /*#__PURE__*/React.createElement("a", {
          href: "#",
          onClick: function onClick(evt) {
            return evt.preventDefault();
          }
        }, "\u7533\u8BF7\u6743\u9650"))),
        okText: '关闭',
        onCancel: function onCancel() {
          apiErrorCount = 0;
        }
      });
    } else {
      AsyncMessage.error(err.errmsg);
    }
  });

  // key: /disposal/api
  // value: /api/op/disposal/api
  request.addMap('/disposal/api', '/api/op/disposal/api');
  request.CONFIG.getHeaders = function () {
    var GID = QS.parse(location.search)['GID'];
    if (Array.isArray(GID)) {
      GID = GID[0];
    }
    var headerObj = _defineProperty(_defineProperty({}, 'upm-appid', 'a9866bdeb1144cb4a538c2d30584b3d7'), 'upm-groupid', GID || '');
    window.windowkdevTestGray && Object.assign(headerObj, _defineProperty({}, 'kdev-context', window.windowkdevTestGray));
    return headerObj;
  };
  request.CONFIG.handleLogin = function () {
    var service = window.location.origin + '/sso/login?redirect=' + encodeURIComponent(window.location.href);
    window.location.href = 'https://sso.corp.kuaishou.com/cas?service=' + encodeURIComponent(service);
  };
  request.CONFIG.loginCheck = function (resp) {
    var val = resp;
    if (val.result === 51) {
      var service = window.location.origin + '/sso/login?redirect=' + encodeURIComponent(window.location.href);
      window.location.href = val.url + '?service=' + encodeURIComponent(service);
      return false;
    }
    return true;
  };
  request.CONFIG.handleSuccessAPIBaseInfo = function (abi) {
    abi.time > 300 && uploadAPITime({
      api_method: abi.method,
      api_path: abi.path,
      api_params: abi.params,
      api_time: abi.time
    });
  };
  request.CONFIG.handleErrorAPIBaseInfo = function (abi) {
    if (abi.errType === EAPIErrorType.HTTP) {
      uploadHttpError({
        api_method: abi.method,
        api_path: abi.path,
        api_params: abi.params,
        error_code: abi.errno,
        error_msg: abi.errmsg
      });
    }
    if (abi.errType === EAPIErrorType.BUSINESS) {
      uploadBusinessError({
        api_method: abi.method,
        api_path: abi.path,
        api_params: abi.params,
        error_code: abi.errno,
        error_msg: abi.errmsg
      });
    }
  };
  // 埋点接口重定向
  request.CONFIG.handleRedirectLogin = function (abi) {
    sendCustomLoginRedirect({
      result_type: abi.path,
      message: abi.params,
      extra_info: JSON.stringify({
        lastMouseMoveTime: window['lastMouseMoveTime'] || 0,
        lastClickTime: window['lastClickTime'] || 0,
        lastMinTime: Math.min(window['lastMouseMoveTime'] || 0, window['lastClickTime'] || 0)
      })
    });
  };

  // team 必填弹窗
  initRequest_isSend();
}